var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_vm._v("\n  Not implemented yet. Please wait.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }